import {http} from 'lib/httpAxios'

export default {
  retrieveAppointmentDocumentList (accountCode) {
    return http.get(`/appointments/dispatch/${accountCode}/files`)
    .then((response) => Promise.resolve(response))
    .catch((error) => Promise.reject(error))
  },
  uploadApointmentFile (parameters) {
    return http.post(`/appointments/dispatch/${parameters.accountCode}`, parameters.file)
    .then((response) => Promise.resolve(response))
    .catch((error) => Promise.reject(error))
  },
  saveApointmentFile (parameters) {
    return http.post(`/appointments/dispatch/${parameters.accountCode}/save`, parameters.data)
    .then((response) => Promise.resolve(response))
    .catch((error) => Promise.reject(error))
  },
  retrieveVehicleList (accountCode) {
    return http.get(`/distribution/vehicles/${accountCode}`)
    .then((response) => Promise.resolve(response))
    .catch((error) => Promise.reject(error))
  },
  retrieveVehicleLocation (plate) {
    return http.get(`/distribution/vehicle/${plate}/location`)
    .then((response) => Promise.resolve(response))
    .catch((error) => Promise.reject(error))
  }
}



// WEBPACK FOOTER //
// ./src/vuex/api/services/dispatch.js